import React from 'react';
import { Dropdown } from 'react-bootstrap';

import './BasicDropdown.scss';
import { BasicDropdownProps } from './types';

const BasicDropdown = <T,>({ type, selectedType, onSelectType } : BasicDropdownProps<T>) => {
  return (
    <Dropdown className={'basic-dropdown-' + type.name}>
      <Dropdown.Toggle id={'dropdown-basic-' + type.name} style={{width: '100%'}}>
        {
          (!selectedType || type.types.findIndex(type => {
            return JSON.stringify(type) === JSON.stringify(selectedType);
          }) === -1) ?
            'Select' :
            selectedType.name
        }
      </Dropdown.Toggle>
      <Dropdown.Menu className="basic-dropdown-menu">
        {type.types.map((type, index) => (
          <Dropdown.Item key={index} id={'drop-down-item-' + type.name } onClick={() => onSelectType(type)}>
            {type.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default BasicDropdown;